import BaseModel from "../../../core/components/input-widget/BaseModel";
import i18n from "@/shared/i18n";
import {getPhoneRuleObj, LOT_NO_REGEX} from "@/plugins/vee-validate";

export default class BatchTelephoneBidGenerationModel extends BaseModel {
  lot_no = null;
  amount = null;
  phone = null;
  phone2 = null;
  clerk_uuid = null;
  type = 'telephone';
  status = 'confirmed';
  description = null;
  date = null;
  time = null;
  extra_step = null;

  static TRANSLATABLE_FIELDS = [];

  rules = {
    lot_no: {
      required: true,
      regex: LOT_NO_REGEX
    },
    type: 'required',
    bidder_uuid: 'required',
    // amount: 'required',
    status: 'required',
    phone: getPhoneRuleObj(true),
    phone2: getPhoneRuleObj(),
  };

  attributeLabels = {
    lot_no: i18n.t('Lot'),
    amount: i18n.t('Amount'),
    bidder_uuid: i18n.t('Paddle Number'),
    type: i18n.t('Type'),
    status: i18n.t('Status'),
    date: i18n.t('Date'),
    bidder: i18n.t('Bidder'),
    auction: i18n.t('Auction'),
    sale_no: i18n.t('Sale'),
    phone: i18n.t('Phone 1'),
    phone2: i18n.t('Phone 2'),
    clerk_uuid: i18n.t('Clerk'),
    description: i18n.t('Description'),
    extra_step: i18n.t('Extra Step'),
    time: i18n.t('Time'),
  };

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }
}
